import { Component, signal, computed } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientService } from '../../services/patient.service';
import { AppointmentService } from '../../services/appointment.service';
import { Patient } from '../../models/patient.model';
import { Appointment } from '../../models/appointment.model';
import { ButtonComponent, InputComponent } from '../ui';

@Component({
  selector: 'app-patient-console',
  standalone: true,
  imports: [CommonModule, DatePipe, ButtonComponent, InputComponent],
  templateUrl: './patient-console.component.html',
  styleUrl: './patient-console.component.css'
})
export class PatientConsoleComponent {
  patientId = signal<string>('');
  patient = signal<Patient | null>(null);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private patientService: PatientService,
    private appointmentService: AppointmentService
  ) {
    this.route.paramMap.subscribe(params => {
      const id = params.get('patientId') || '';
      this.patientId.set(id);
      this.patient.set(this.patientService.getPatientById(id) ?? null);
    });
  }

  private appointmentsForPatient = computed(() => {
    const appointments = this.appointmentService.getAppointments()();
    return appointments.filter(a => a.patientId === this.patientId());
  });

  queueAppointments = computed(() =>
    this.appointmentsForPatient().filter(a => ['Scheduled', 'Confirmed'].includes(a.status))
  );

  seenAppointments = computed(() =>
    this.appointmentsForPatient().filter(a => ['Completed', 'In Progress'].includes(a.status))
  );

  cancelledAppointments = computed(() =>
    this.appointmentsForPatient().filter(a => a.status === 'Cancelled')
  );

  displayDate = computed(() => {
    const upcoming = this.queueAppointments()[0];
    if (upcoming) {
      return new Date(upcoming.date);
    }
    const created = this.patient()?.createdAt;
    return created ? new Date(created) : new Date();
  });

  startConsult() {
    this.router.navigate(['/consultation'], { queryParams: { patientId: this.patientId() } });
  }
}

